// Utility functions for comparing types while sorting
import moment from 'moment';

export const stringCompare = (a: string, b: string, ascending: boolean) => {
  const difference = a.localeCompare(b, undefined, { sensitivity: 'base' });
  return ascending ? difference : -difference;
};
export const dateCompare = (
  a: string | number | null,
  b: string | number | null,
  ascending: boolean,
) => {
  const difference = a && b ? moment(a).diff(b) : b ? 1 : a ? -1 : 0;
  return ascending ? difference : -difference;
};
